// Generated by GitHub Copilot

/**
 * All GCC journey groups, their tabs, asset cards and "Why Accenture" items.
 * The `slug` field is used as the URL path segment: /offering/:slug
 */
export const OFFERING_GROUPS = [
  {
    groupLabel: 'No GCC',
    groupSlug: 'no-gcc',
    offerings: [
      {
        slug: 'exploring-gccs',
        label: 'Exploring GCCs',
        title: "Growth and Cost Pressures tell us our Operating Model isn't working",
        description:
          'Not sure if a GCC is right for you, or just starting to explore it? We help answer the "why," "where," and "how" — building a blueprint that unlocks long-term value.',
        assets: [
          {
            category: 'Conversation Starter',
            title: 'Greenfield GCC Narrative',
            description:
              'Open first-time GCC talks with a story on cost, speed and de-risked build.',
            links: [
              { label: 'GCC stage 0', url: 'https://kxdocuments.accenture.com/contribution/7ac72249-9ce7-4ea9-9758-469602f0f856' },
              { label: 'Industry Narratives', url: '/industry-narratives' },
            ],
          },
          {
            category: 'Industry Origination',
            title: 'Industry-Specific Dashboards',
            description:
              'Showcase Industry-Led Insights and Savings to drive early-stage conversations.',
            link: 'Industry Origination Dashboards',
             url: 'https://app.powerbi.com/groups/me/reports/25b72a87-355d-489a-9349-69da7a5eda3f/45b3d4de264a09affc1a?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi',
          },
          {
            category: 'Archetype Pack',
            title: 'Design Archetype Pack',
            description:
              'Shape the GCC Blueprint – Strategy, Vision, Governance, Model and Talent.',
            link: 'Design, Setup & Mobilization Playbook',
            url:'https://kxdocuments.accenture.com/contribution/ab5be96b-e8d0-4275-98b3-b7abbfa94432?preview=1&referrer=https://reinventionconsole.accenture.com/digitalbriefcase'
          },
          {
            category: 'Location Strategy',
            title: 'Talent Led Location Blueprint',
            description:
              'Find the optimal talent-rich, cost-effective location via GCC Navigator.',
            // link: 'GCC Navigator | Location strategy stage 0',
            // url:'https://collections.accenture.com/fileviewer/6b69df04-656a-4a12-927c-016e232fa136?pinid=48072e8f-e77b-489d-8a67-35afe31aa79f'

            links:[
                { label: 'GCC Navigator', url: 'https://reinventionconsole.accenture.com/console/explore/asset-details/ZTVjYWE1MjktOTRjNy00MDNhLWFhOWUtN2RiM2FjNmRkODY1/NmY4MDBjMDQtZDBlYS00MTI5LTk5YTUtMTRjZGY4MDAyYTkx' },
                { label: 'Location Strategy Stage 0', url: 'https://collections.accenture.com/fileviewer/6b69df04-656a-4a12-927c-016e232fa136?pinid=48072e8f-e77b-489d-8a67-35afe31aa79f' },
            ]
          },
          {
            category: 'AI Enabled GCC',
            title: 'AI First GCC Preview',
            description:
              'Bring the AI-first GCC to life – show the future state before scope is set.',
            link: ' AI Powered GCC',
            url:'https://kxdocuments.accenture.com/Contribution/e844826f-9cd2-4cd0-b27b-42abbd9e0403'
          
          },
          {
            category: 'GCC Credentials',
            title: 'Proven Enterprise Track Record',
            description:
              'Build confidence with credentials of early GCC talks turned into strategies.',
            link: 'Client Stories on Web app',
            url:'/clientstories'
          },
        ],
        whyAccenture: [
          {
            title: 'Operating DNA',
            description:
              '200,000+ India practitioners and 30+ years of GCC delivery',
          },
          {
            title: 'AI-First from Day One',
            description:
              'Every GCC we build is designed for intelligent operations from the ground up',
          },
        ],
      },
      {
        slug: 'setup-and-launch',
        label: 'GCC Setup and Launch',
        title: 'We want to set up a GCC - and get it right from the start',
        description:
        'Ready to launch your GCC? Accenture accelerates your journey to Day-1 stability with end-to-end implementation support—from setup architecture to talent seeding for smooth operations.',
        assets: [
          {
            category: 'Conversation Starter',
            title: 'GCC Setup and Mobilization Narrative',
            description:
              'From GCC decision to Day-1 stability — let\'s design your setup model, seed talent and launch fast',
            link: 'GCC Stage 0',
            url:'https://kxdocuments.accenture.com/contribution/7ac72249-9ce7-4ea9-9758-469602f0f856'
          },
          {
            category: 'Archetype Pack',
            title: 'ABO Setup Archetype Pack',
            description:
              'Drive end-to-end setup with playbook for entity, talent, tech and transition.',
            link: 'Design, Setup & Mobilization Playbook',
            url:'https://kxdocuments.accenture.com/contribution/ab5be96b-e8d0-4275-98b3-b7abbfa94432?preview=1&referrer=https://reinventionconsole.accenture.com/digitalbriefcase'
          },
          {
            category: 'Archetype Pack',
            title: 'BOT Setup Pack',
            description:
              'Execute every Build-Operate-Transfer phase - from setup to seamless handover.',
            link: 'BOT Playbook',
            url:'https://kxdocuments.accenture.com/contribution/48f7e2db-d406-4051-8e5c-1f56ae840cef'
          },
          {
            category: 'ANSR Partnership Brief',
            title: 'ANSR Partnership Brief',
            description:
              'Power reinvention via ANSR - Digital-First Ops, Global Talent and Innovation.',
            link: 'Joint Value proposition with ANSR',
            url:'https://kxdocuments.accenture.com/contribution/fd64fa2d-b216-4acb-8e06-ba239e5bac75'
          },
          {
            category: 'GCC Platform',
            title: 'Setup with Elevate X',
            description:
              'GCC transition across site setup, process build and talent — for stable Day-1.',
            link: 'Elevate X',
            url:'https://reinventionconsole.accenture.com/console/explore/asset-details/NmQwZjJkNjAtY2QxNC00NjkyLWJmYjYtZmIzMWU4MDU0YjM4/NjZhYjc3YmEtZWFkZi00NDFiLTljZmQtODE1MDAxNDJiYzE0/S25vd2xlZGdlIEdyYXBo'
          },
          {
            category: 'GCC Credentials',
            title: 'GCC Credentials',
            description:
              'Surface the right client story by industry, archetype, geography and function.',
            link: 'Client Stories on Web app',
            url:'/clientstories'
          },
        ],
        whyAccenture: [
          {
            title: 'ANSR Partnership',
            description:
              'Supported 500+ GCCs globally, combining ANSR build-&-scale expertise with Acn reinvention.',
          },
          {
            title: '45+ years',
            description:
              'building and running managed services at scale (20+ years in India)',
          },
        ],
      },
    ],
  },
  {
    groupLabel: 'Existing GCC',
    groupSlug: 'existing-gcc',
    offerings: [
      {
        slug: 'scale-expansion',
        label: 'Scale GCCs',
        title: 'Our GCC is running - but we know it could do more',
        description:
          'GCC is established but limited in scope. Accenture expands into talent-rich markets using proven BOTT methodology while delivering flexible, on-demand talent for project-driven needs.',
        assets: [
          {
            category: 'Conversation Starter - 1',
            title: 'Powered by GCC Maturity Assessment',
            description:
              'Benchmarks GCC maturity across key dimensions to identify gaps and prioritize acceleration actions.',
            link: 'GCC Maturity Diagnostics',
            url:'https://kxdocuments.accenture.com/contribution/6922d077-e7fa-4782-8bc5-798c9944a2fa'
          },
          {
            category: 'Conversation Starter - 2',
            title: "Reinvent your client's GCCs",
            description:
              'A practical guide for enterprises scaling GCCs into talent-rich locations with deeper functional value.',
            link: 'GCC Reinvention Playbook- upcoming',
            url:''
          },
          {
            category: 'Archetype Pack',
            title: 'GCC Tech Reinvention',
            description:
              'AI-led Blueprint to modernize GCC tech stacks, operating models and accelerate digital outcomes.',
            link: 'GCC Tech Reinvention Playbook - upcoming',
            url:''
          },
          {
            category: 'GCC Platform',
            title: 'One Platform, End-to-End',
            description:
              'Monitor and Transform Capabilities to boost efficiency, improve user experiences and accelerate business outcomes',
            link: 'GCC Platform Overview',
            url:'https://kxdocuments.accenture.com/contribution/e2cddcf4-80cc-447e-a918-eae30ff2448d'
          },
          {
            category: 'GCC Credentials',
            title: 'Proven at every scale',
            description:
              'Real client stories of GCCs that solved onshore talent gaps with proven capability delivery.',
            link: 'Client Stories on Web app',
            url:'/clientstories'
          },
        ],
        whyAccenture: [
          {
            title: 'Scale with confidence',
            description:
              "We've done this at every scale — from 200 to 20,000 people.",
          },
          {
            title: 'Location Intelligence',
            description:
              'Our data on India talent markets is deeper than any advisory firm. We live in these markets.',
          },
        ],
      },
      {
        slug: 'value-and-ai-readiness',
        label: 'Maximize value with AI',
        title: 'We want more from our GCC - more functions, more AI, more value',
        description:
          "GCC's value remains untapped and workforce lacks AI readiness. Accenture unlocks hidden value and modernizes operations through diagnostics, reinvention and AI upskilling initiatives.",
        assets: [
          {
            category: 'Conversation Starter - 1',
            title: "Reinvent for What's Next",
            description:
              'Assess maturity, reinvent operations and build AI readiness - move GCCs from traditional to next.',
            link: 'GCC Reinvention Playbook- upcoming',
            url:''
          },
          {
            category: 'Conversation Starter - 2',
            title: 'GCC Maturity Assessment',
            description:
              'Use a framework that maps current GCC maturity, future ambition and the gaps between.',
            link: 'GCC Maturity Diagnostics',
            url:'https://kxdocuments.accenture.com/contribution/6922d077-e7fa-4782-8bc5-798c9944a2fa'
          },
          {
            category: 'Archetype Pack',
            title: 'AI Archetype Pack',
            description:
              'AI-led transformation and operating model reset for underperforming GCCs.',
            link: 'AI Academy for GCCs - upcoming',
          },
          {
            category: 'AI Enabled GCC',
            title: 'AI Archetype Pack',
            description:
              'Show the client what a modern, AI-first GCC looks and feels like — before scope is finalized.',
            link: 'AI Powered GCC',
            url:'https://kxdocuments.accenture.com/Contribution/e844826f-9cd2-4cd0-b27b-42abbd9e0403'
          },
          {
            category: 'GCC Platform',
            title: 'Value delivered with Gen Wizard & Synops​',
            description:
              'AI-powered tech and operations for GCCs, combining modern architecture, automation and scalable process redesign.​',
            link: 'GenWizard',
            // url:'https://reinventionconsole.accenture.com/console/genwizard'
              links: [
              { label: 'GenWizard', url: 'https://reinventionconsole.accenture.com/console/genwizard' },
              { label: 'SynOps', url: 'https://reinventionconsole.accenture.com/ter/CustomMenu1?indSegmentID=NDc3YmU1MWMtOGE3NS00ZWExLTlmNjQtOGFjZWMzMjQxYjRi&Source=S25vd2xlZGdlIEdyYXBo' },
            ],
          },
          {
            category: 'GCC Credentials',
            title: 'Proven at every scale',
            description:
              'Cases where GCCs solved an onshore talent gap — capability delivered, attrition managed',
            link: 'Client Stories on Web app',
            url:'/clientstories'
          },
        ],
        whyAccenture: [
          {
            title: 'AI platform, Not just advice',
            description:
              "We don't just design AI strategies - We have a live platform already running in GCCs",
          },
          {
            title: 'Industry Specific Agentic Solutions',
            description:
              '100+ pre built agentic solutions made available to our clients in their GCCs',
          },
        ],
      },
    ],
  },
];

/**
 * Flat lookup map: slug → { offering, group }
 * Allows O(1) lookup from URL slug without scanning nested arrays.
 */
export const OFFERING_BY_SLUG = OFFERING_GROUPS.reduce((acc, group) => {
  group.offerings.forEach((offering) => {
    acc[offering.slug] = { offering, group };
  });
  return acc;
}, {});
